import {
  ROUTE_INDEX,
  ROUTE_SHIPMENTS,
  ROUTE_PREVIEW_BILLING,
  ROUTE_PREVIEW_ORDERS,
  ROUTE_PREVIEW_DASHBOARD,
  ROUTE_PREVIEW_REPORTS,
  ROUTE_SHIPMENT_DETAILS,
} from './constants'
import {ShipmentsPage} from '../pages'

import {
  PreviewBillingPage,
  PreviewOverviewPage,
  PreviewOrdersPage,
  PreviewReportsPage,
} from '../pages/preview'

export default [
  {
    path: ROUTE_INDEX,
    redirectTo: ROUTE_SHIPMENTS,
  },
  {
    path: ROUTE_SHIPMENTS,
    component: ShipmentsPage,
  },
  {
    path: ROUTE_PREVIEW_DASHBOARD,
    component: PreviewOverviewPage,
  },
  {
    path: ROUTE_PREVIEW_ORDERS,
    component: PreviewOrdersPage,
  },
  {
    path: ROUTE_PREVIEW_BILLING,
    component: PreviewBillingPage,
  },
  {
    path: ROUTE_PREVIEW_REPORTS,
    component: PreviewReportsPage,
  },
  {
    path: ROUTE_SHIPMENT_DETAILS,
    component: ShipmentsPage,
  },
]
